import React from 'react';
import { motion } from 'framer-motion';
export function Testimonial() {
  return <section className="py-14 px-4 bg-sage/10" data-id="element-436">
      <div className="max-w-3xl mx-auto" data-id="element-437">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-438">
          <p className="text-xl md:text-2xl font-serif italic text-navy/90 leading-relaxed" data-id="element-439">
            "Tu libro ha sido de mucha bendición para mí. El tratar de estar en
            todo al mismo tiempo es un caos... tu libro me ha ayudado mucho en
            organizarme, en tener más control de todo sin que se me pase algo
            importante. Además ha mejorado mucho mi forma de comunicarme para
            que nuestras vidas no sean tan complejas."
          </p>
          <p className="text-base text-navy/60 font-medium" data-id="element-440">
            — Narce Espinoza, cuidadora 💙
          </p>
        </motion.div>
      </div>
    </section>;
}